var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.cards),function(card){return _c('div',{key:card.phone,staticClass:"card-wrapper col-sm-12 col-md-6 col-lg-4 mb-3 card-hover",attrs:{"data-testid":("card-wrapper-" + (card.id))},on:{"click":function($event){[
      _vm.toggle(card),
      _vm.$emit('set-name', card.name)
    ]}}},[_c('card',_vm._b({},'card',card,false))],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }